import React from 'react';
import TileGroup from './TileGroup';
import ProjectsForeignObject from './ProjectsForeignObject';

interface ComponentConfig {
    component: React.ComponentType<any>;
    props: {
        cx?: number;
        cy?: number;
        r?: number;
        tx?: number;
        ty?: number;
        texture?: string;
    };
    key: string;
}

interface ProjectsProps {
    specialTiles: ComponentConfig[];
    facadeTiles: [number, number][];
    groupCoordinates: [number, number][];
}

const Projects: React.FC<ProjectsProps> = ({ specialTiles, facadeTiles, groupCoordinates }) => {
    return (
        <TileGroup
            specialTiles={specialTiles}
            facadeTiles={facadeTiles}
            groupCoordinates={groupCoordinates}
            groupName="projects"
            displayText="PROJECTS"
            backgroundTexture="/textures/oak_planks.png"
            foreignObjectComponent={ProjectsForeignObject}
            zoomScale={2.5}
        />
    );
};

export default Projects;